import loadingSpinner from './components/loading-spinner'

export class StepConnectedDisconnect {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "connected_disconnect";
  title = "Disconnecting from Temp Stick";

  template = `
  <div class="onboarding-step" data-for="connected_disconnect">
          
    <div class="onboarding-loading">
      <div class="onboarding-loading__animation">${loadingSpinner()}</div>
      <div class="onboarding-loading__text">
        Reconnecting WiFi...
      </div>
    </div>
    
  </div>
  `;

  onBack = () => {

  }

  onActivate = () => {

    // disable the sensor status check
    clearInterval(this.onboarding.status_interval);
    clearInterval(this.onboarding.get_wifi_networks_interval);

    if(this.onboarding.is_connected) {

      if(this.onboarding.sensor.version && this.onboarding.sensor.version >= 2000) {

        // v2 sensor we're done
        this.onboarding.Temp_Stick_Request('GET', '/done', {}, true);

        // explicitly drop the sensor link (Wi-Fi network or Bluetooth)
        setTimeout(() => {
          this.onboarding.Temp_Stick_Disconnect();
        }, 5000);

      } else {

        this.$container.html(`
          <p class="onboarding-guide-instruction">
            You are connected to your sensor and have <b>not completed setup</b>.  
            You need to disconnect from your sensor in your WiFi settings.
          </p>
          
          <p class="onboarding-guide-instruction-smaller">
          The sensor will not send readings until setup is complete.
          </p>
          
          <div class="step-connected-disconnect__go-back">
            <button type="button" class="step-connected-disconnect-go-back-button button button--medium button--black">
              Return to Temp Stick Setup
            </button>
          </div>
        `);

      }

      this.testConnectionCount = 0;
      this.testConnectionInterval = setInterval(() => {

        $.ajax({
          url: window.site.home + "/../connection-test",
          type: 'GET',
          timeout: 2000,
          success: (data) => {

            clearInterval(this.testConnectionInterval);
            this.onboarding.Set_Connected(false);
            window.location.href = window.site.home + "/sensors";

          },
          error: (xhr, status, error) => {

            if(this.onboarding.sensor.version && this.onboarding.sensor.version >= 2000) {

              // Handle error response
              this.testConnectionCount++;

              if (this.testConnectionCount > 30) {

                this.$container.html('<p>You might need to manually connect to your Wi-Fi</p>');

                if (this.testConnectionCount > 120) {
                  this.$container.html("<p>Your device is currently offline, you will need to manually change your Wi-Fi connection.</p>");
                  clearInterval(this.testConnectionInterval);
                }
              }

            }

          }
        });

      }, 2500);

    } else {
      window.location.href = window.site.home + "/sensors";
    }
  }

  bindActions = () => {

    this.$container = $(this.onboarding.container).find('.onboarding-step[data-for="connected_disconnect"]');

    this.$container.on('click', '.step-connected-disconnect-go-back-button', () => {
      this.onboarding.goToStep(this.onboarding.disconnect_return_step || 'connected_wifi_select');
    });

  }

}
